import { useDocumentDataOnce } from "react-firebase-hooks/firestore";
import { doc, getFirestore } from "firebase/firestore";
import { RichTextEditor } from "../../components/richText/RichTextEditor.js";

export const AboveAndBeyondPane = (props) => {
  const studentId = props.studentId;
  const qtrId = props.qtrId;
  const psetId = props.psetId;

  // answers path holds the submitted project id, which we use to get the whole project data
  const answerPath = `users/${studentId}/${qtrId}/${psetId}/answers/aboveAndBeyond`;
  const [answerData, answerDataLoading, answerDataError] = useDocumentDataOnce(
    doc(getFirestore(), answerPath)
  );

  const submittedProjectId = answerData?.submittedProjectId;
  const projectPath = submittedProjectId
    ? `users/${studentId}/${qtrId}/${psetId}/projects/${submittedProjectId}`
    : null;

  const [projectData, projectDataLoading, projectDataError] =
    useDocumentDataOnce(projectPath ? doc(getFirestore(), projectPath) : null);

  if (answerDataError) {
    return <div className="p-2">Error loading answer data</div>;
  }

  if (answerDataLoading) {
    return <div className="p-2">Loading answer data...</div>;
  }

  if (!submittedProjectId) {
    return <div className="p-2">No project submitted</div>;
  }

  if (projectDataError) {
    return <div className="p-2">Error loading project data</div>;
  }

  if (projectDataLoading) {
    return <div className="p-2">Loading project data...</div>;
  }

  if (!projectData) {
    return <div className="p-2">Project not found</div>;
  }

  return (
    <div className="p-2">
      <h5>{projectData.name}</h5>
      {projectData.specificProject && projectData.selectedQuestion && (
        <div className="mb-1 text-muted small">
          <em>Attached to question: {projectData.selectedQuestion}</em>
        </div>
      )}
      {/* Files */}
      {projectData.files && projectData.files.length > 0 && (
        <div className="mb-3">
          <strong>Project Files:</strong>
          <ul className="mt-1">
            {projectData.files.map((file, idx) => (
              <li key={idx}>
                <a href={file.url} target="_blank" rel="noopener noreferrer">
                  {file.name || `File ${idx + 1}`}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Links */}
      {projectData.submissionLinks &&
        projectData.submissionLinks.length > 0 && (
          <div className="mb-3">
            <strong>Project Links:</strong>
            <ul className="mt-1">
              {projectData.submissionLinks.map((link, idx) => (
                <li key={idx}>
                  <a href={link} target="_blank" rel="noopener noreferrer">
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      {/* Video */}
      {projectData.videoUrl && (
        <div className="mb-3">
          <strong>Project Video Description:</strong>
          {projectData.videoType === "link" ? (
            <div className="mt-1">
              <a
                href={projectData.videoUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {projectData.videoUrl}
              </a>
            </div>
          ) : (
            <div className="mt-1">
              <video
                src={projectData.videoUrl}
                controls
                style={{ maxWidth: "100%", maxHeight: "400px" }}
              >
                Your browser does not support the video tag.
              </video>
            </div>
          )}
        </div>
      )}

      {/* Description */}
      {projectData.description !== undefined && (
        <div className="mb-3">
          <strong>Project Description:</strong>
          <div className="mt-1">
            <RichTextEditor
              user={{ uid: studentId }}
              editable={false}
              firebaseDocPath={projectPath}
              collaborative={false}
              contentKey="description"
              minHeight={100}
            />
          </div>
        </div>
      )}
    </div>
  );
};
